import { useOptionalSession } from './chunk-7QYYSJGW.js';
import * as React from 'react';
import { grantedEntitlements } from '@authe/fe-commons/plans';
import { resolveLoadProfile, budgetFor } from '@authe/fe-commons/budgets';
import { TX_TENANCY_SCOPES, TX_SCOPES, offeredRungs, offeredTxTenancyScopes, offeredTxScopes, ladderIsChoosable, ladderIsShared } from '@authe/fe-commons/tenancy';
import { jsx } from 'react/jsx-runtime';

var UNKNOWN = {
  plan: null,
  granted: null,
  profile: "standard",
  txScopes: TX_SCOPES,
  txTenancyScopes: TX_TENANCY_SCOPES,
  offeredRungs: null
};
var PlanContext = React.createContext(UNKNOWN);
function PlanProvider({
  plan,
  overrides,
  subscriptionMetadata,
  children
}) {
  const session = useOptionalSession();
  const manager = session?.manager;
  const livePlanId = plan?.id ?? null;
  React.useEffect(() => {
    if (!manager || !livePlanId) return;
    void manager.reconcilePlan(livePlanId);
  }, [manager, livePlanId]);
  const value = React.useMemo(
    () => ({
      plan: plan ?? null,
      granted: plan ? grantedEntitlements(plan, overrides ?? {}) : null,
      profile: resolveLoadProfile(plan?.metadata ?? null, subscriptionMetadata ?? null),
      txScopes: offeredTxScopes(plan?.metadata ?? null, subscriptionMetadata ?? null),
      txTenancyScopes: offeredTxTenancyScopes(plan?.metadata ?? null, subscriptionMetadata ?? null),
      offeredRungs: offeredRungs(plan?.metadata ?? null, subscriptionMetadata ?? null)
    }),
    [plan, overrides, subscriptionMetadata]
  );
  return /* @__PURE__ */ jsx(PlanContext.Provider, { value, children });
}
function usePlan() {
  return React.useContext(PlanContext);
}
function useEntitlement(entitlement) {
  const { granted } = usePlan();
  return granted === null || granted.has(entitlement);
}
function useEntitled() {
  const { granted } = usePlan();
  return React.useCallback(
    (entitlement) => !entitlement || granted === null || granted.has(entitlement),
    [granted]
  );
}
function useLoadBudget(name) {
  const { profile } = usePlan();
  return React.useMemo(() => budgetFor(name, profile), [name, profile]);
}
function useOfferedTxScopes() {
  return usePlan().txScopes;
}
function useOfferedTxTenancyScopes() {
  return usePlan().txTenancyScopes;
}
function useOfferedRungs() {
  return usePlan().offeredRungs;
}
function useLadderChoosable() {
  return ladderIsChoosable(usePlan().offeredRungs);
}
function useLadderShared() {
  return ladderIsShared(usePlan().offeredRungs);
}

export { PlanProvider, useEntitled, useEntitlement, useLadderChoosable, useLadderShared, useLoadBudget, useOfferedRungs, useOfferedTxScopes, useOfferedTxTenancyScopes, usePlan };
//# sourceMappingURL=chunk-3IGPV75E.js.map
//# sourceMappingURL=chunk-3IGPV75E.js.map